<template>
  <div
    class="mb-5"
  >
    <b-navbar 
      toggleable="lg" 
      type="dark" 
      variant="dark"
      class=""
    >
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
            <b-nav-item to="/">Startseite</b-nav-item>
            <b-nav-item to="/projekt">Projekt</b-nav-item>
            <b-nav-item to="/impressum">Impressum</b-nav-item>
            <b-nav-item to="/datenschutz">Datenschutz</b-nav-item>
            <b-nav-item to="/kontakt">Kontakt</b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
            <b-nav-form @submit.prevent="search">
            <b-form-input size="sm" class="mr-sm-2" placeholder="Suche" v-model="searchString"></b-form-input>
            <b-button size="sm" class="mr-2 my-2 my-sm-0" type="submit">Suche</b-button>
            </b-nav-form>

            <b-nav-item-dropdown text="Lang" right>
            <b-dropdown-item href="#">EN (comming soon ...)</b-dropdown-item>
            <b-dropdown-item href="#">DE</b-dropdown-item>
            </b-nav-item-dropdown>
        </b-navbar-nav>
        </b-collapse>
    </b-navbar>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'navigation',
  components: {
        
  },
  data () {
      return {
          searchString: ''
      }
  },
  methods: {
      ...mapActions({
        setSearchString: 'setSearchString'
    }),
    search() {
      this.setSearchString(this.searchString)
      this.$store.dispatch('searchItems', this.searchString)
      this.searchString = null
      this.$router.push('/')
    }
  },
  computed: {
    ...mapGetters({
      
    })
  },
  created () {
      
  } 
}
</script>
